import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';

const faqItems = [
  {
    question: '韩漫画网站的漫画是免费的吗？',
    answer: '是的！韩漫画网站上的所有漫画均为免费在线阅读。我们致力于为漫画爱好者提供最优质的韩国漫画在线阅读服务，无需注册即可畅享海量免费漫画资源。',
  },
  {
    question: '网站多久更新一次漫画？',
    answer: '我们每日更新漫画内容，与韩国官方同步更新最新话数。您可以在"最新更新"栏目中查看最近更新的所有漫画，确保不错过任何精彩内容。',
  },
  {
    question: '需要注册账号才能阅读吗？',
    answer: '不需要。我们提供免注册、免登录的阅读体验，您可以直接在网站上浏览和阅读所有漫画。如果您希望能收藏喜欢的漫画，可以选择注册账号。',
  },
  {
    question: '支持手机阅读吗？',
    answer: '当然支持！韩漫画网站采用响应式设计，完美适配手机、平板和电脑等各种设备。无论您使用什么设备，都能获得流畅舒适的漫画阅读体验。',
  },
  {
    question: '如何搜索想看的漫画？',
    answer: '您可以使用网站顶部导航栏的搜索框输入漫画名称或作者名进行搜索。此外，您也可以通过分类导航按类型浏览感兴趣的漫画。',
  },
  {
    question: '漫画画质如何？',
    answer: '我们提供高清画质的漫画阅读体验，所有漫画图片均经过优化处理，在保证清晰度的同时确保加载速度。无论是电脑还是手机，都能享受极致的阅读体验。',
  },
];

const highlights = [
  {
    icon: 'ri-book-open-line',
    title: '海量资源',
    desc: '收录数千部热门韩国漫画，涵盖恋爱、奇幻、动作、搞笑等多种类型，满足不同读者的口味需求。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '与韩国官方同步更新，第一时间为您带来最新话数。每日都有新内容，追更不停歇。',
  },
  {
    icon: 'ri-hd-line',
    title: '高清画质',
    desc: '所有漫画均采用高清画质呈现，细节清晰可见，为您带来极致的视觉享受。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    desc: '完美支持手机、平板和电脑阅读，随时随地畅享漫画世界。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    desc: '网站采用先进的安全防护技术，保障您的阅读体验安全无忧。',
  },
  {
    icon: 'ri-user-heart-line',
    title: '完全免费',
    desc: '坚持免费阅读理念，无需付费即可畅享全部漫画资源。',
  },
];

export default function About() {
  return (
    <>
      <Navbar />
      <main className="pt-16">
        <div className="max-w-[1280px] mx-auto">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />

          <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "name": "关于我们 - 韩漫网站",
            "description": "韩漫网站支持韩国漫画在线阅读，提供最新免费漫画大全，资源丰富画质佳，是您休闲娱乐的好去处。",
            "url": "https://www.hanmanwang.com/about",
            "inLanguage": "zh-CN",
            "isPartOf": {
              "@type": "WebSite",
              "name": "韩漫网",
              "url": "https://www.hanmanwang.com/"
            },
            "about": {
              "@type": "Organization",
              "name": "韩漫网",
              "description": "韩漫网站支持韩国漫画在线阅读，提供最新免费漫画大全。",
              "url": "https://www.hanmanwang.com/",
              "contactPoint": {
                "@type": "ContactPoint",
                "email": "contact@hanmanwang.com",
                "contactType": "customer service",
                "availableLanguage": ["Chinese"]
              }
            }
          }) }} />

          <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "首页",
                "item": "https://www.hanmanwang.com/"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "关于我们"
              }
            ]
          }) }} />

          <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": faqItems.map((item) => ({
              "@type": "Question",
              "name": item.question,
              "acceptedAnswer": {
                "@type": "Answer",
                "text": item.answer
              }
            }))
          }) }} />

          <div className="px-4 md:px-6 py-6">
            <section className="text-center mb-14">
              <h1 className="text-3xl font-heading text-foreground-900 mb-4">
                <strong>关于韩漫画</strong>
              </h1>
              <p className="text-foreground-500 max-w-2xl mx-auto leading-relaxed text-sm">
                韩漫画网站是一个专注于<strong>韩国漫画在线阅读</strong>的平台，致力于为广大漫画爱好者提供最新、最全的免费漫画资源。我们收录了海量热门韩国漫画，每日同步更新，以高清画质和流畅的阅读体验，成为您休闲娱乐的理想选择。
              </p>
            </section>

            <section className="mb-14" aria-label="品牌优势">
              <h2 className="text-xl font-heading text-foreground-900 text-center mb-8">
                <strong>为什么选择韩漫画？</strong>
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {highlights.map((item) => (
                  <div
                    key={item.title}
                    className="p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 group"
                  >
                    <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                      <i className={`${item.icon} text-xl`}></i>
                    </div>
                    <h3 className="text-base font-medium text-foreground-900 mb-2 whitespace-nowrap">
                      {item.title}
                    </h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                ))}
              </div>
            </section>

            <section className="mb-14" aria-label="用户口碑">
              <div className="bg-background-50 rounded-xl border border-background-200/70 p-8 md:p-10">
                <h2 className="text-xl font-heading text-foreground-900 text-center mb-8">
                  <strong>用户口碑</strong>
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="text-center p-5">
                    <div className="text-4xl font-bold text-primary-500 mb-2 whitespace-nowrap">50万+</div>
                    <p className="text-sm text-foreground-500">日活跃用户</p>
                  </div>
                  <div className="text-center p-5">
                    <div className="text-4xl font-bold text-primary-500 mb-2 whitespace-nowrap">5000+</div>
                    <p className="text-sm text-foreground-500">漫画资源</p>
                  </div>
                  <div className="text-center p-5">
                    <div className="text-4xl font-bold text-primary-500 mb-2 whitespace-nowrap">4.8</div>
                    <p className="text-sm text-foreground-500">用户满意度评分</p>
                  </div>
                </div>
                <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="p-5 rounded-lg bg-background-100">
                    <div className="flex items-center gap-1 mb-2">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <i key={star} className="ri-star-fill text-amber-400 text-sm"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      "韩漫画是我用过最好的漫画阅读网站！更新速度快，画质清晰，分类也很全。每天必刷，强烈推荐给喜欢韩国漫画的朋友！"
                    </p>
                    <p className="text-xs text-foreground-400 mt-2">—— 漫画迷小王</p>
                  </div>
                  <div className="p-5 rounded-lg bg-background-100">
                    <div className="flex items-center gap-1 mb-2">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <i key={star} className="ri-star-fill text-amber-400 text-sm"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      "一直在找能看韩国漫画的网站，终于找到了韩漫画！资源真的很多，而且完全免费，手机上看体验也很好，真是太棒了！"
                    </p>
                    <p className="text-xs text-foreground-400 mt-2">—— 漫画达人小李</p>
                  </div>
                </div>
              </div>
            </section>

            <section className="mb-10" aria-label="常见问题">
              <h2 className="text-xl font-heading text-foreground-900 text-center mb-8">
                <strong>常见问题</strong>
              </h2>
              <div className="max-w-3xl mx-auto space-y-3">
                {faqItems.map((item, index) => (
                  <details
                    key={index}
                    className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
                  >
                    <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-100 transition-colors">
                      <h3 className="text-sm font-medium text-foreground-800 pr-4">
                        {item.question}
                      </h3>
                      <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform duration-200 flex-shrink-0"></i>
                    </summary>
                    <div className="px-5 pb-4">
                      <p className="text-sm text-foreground-500 leading-relaxed">
                        {item.answer}
                      </p>
                    </div>
                  </details>
                ))}
              </div>
            </section>

            <section className="mb-10" aria-label="联系方式">
              <div className="bg-primary-50 rounded-xl border border-primary-200/50 p-8 md:p-10 text-center">
                <h2 className="text-xl font-heading text-foreground-900 mb-3">
                  <strong>联系我们</strong>
                </h2>
                <p className="text-sm text-foreground-500 mb-6 max-w-lg mx-auto">
                  如果您有任何问题、建议或合作意向，欢迎通过以下方式联系我们。我们会在24小时内回复您的消息。
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
                  <div className="flex items-center gap-2 text-sm text-foreground-600">
                    <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                      <i className="ri-mail-line"></i>
                    </span>
                    <span>contact@hanmanwang.com</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-foreground-600">
                    <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                      <i className="ri-customer-service-2-line"></i>
                    </span>
                    <span>在线客服：9:00 - 22:00</span>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}